import { Component } from '@angular/core';

@Component({
  selector: 'ui-modal-footer',
  templateUrl: './modal-footer.component.html',
  styleUrls: [ './modal-footer.component.less' ],
})
export class UiModalFooterComponent {}
